import { useEffect, useRef, useState } from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useNavigate
} from "react-router-dom";
import MTable from '../../Components/MTable/MTable';
import { getAllMHCTransactions } from '../../Service/LogService';
import Swal from 'sweetalert2';
import Overlay from '../../Components/Overlay';
import moment from 'moment';
import 'moment/locale/id';

const { $ } = window;
const TransactionMHC = () => {
    moment.locale('id');
    const navigate = useNavigate();
    const tableStock = useRef();    
    const [state, setState] = useState({ processing : false });
    const [log_detail, setLogDetail] = useState({params: "", sessiondate:""});
    const onView = (item) => {
        setLogDetail({params:item.parameter, sessiondate: item.sessiondate, response: item.response});
        $("#modal-trans").modal();
    }

    const onCloseDetailModal = (e) =>{
        e.preventDefault();
        $("#modal-trans").modal('hide');
    }   
    const columns = [
        { id: 1, title: 'Trans', field: 'trans', sortable: false },
        { id: 2, title: 'Parameter', field: 'parameter', sortable: false, truncated:true, style:{width:"500px", textOverflow:"ellipsis"} },
        { id: 3, title: 'Session Date', field: 'sessiondate', sortable: false, render: (item) => moment(item.sessiondate).format('ll LTS') },
        {
            id: 5,
            title: 'Action',
            render: item => {
                return (
                    <div>
                        <a
                            onClick={() => onView(item)}
                            style={{
                                cursor: 'pointer',
                                color: 'green',
                                display: 'inline-block',
                                marginRight: 20
                            }}
                        >
                            <i className="fas fa-eye" />
                            View
                        </a>
                    </div>
                );
            },
        },
    ];

    const propsTable = { columns, getData: getAllMHCTransactions, showIndex: true, hideFilter:'true', showAddButton:false, customTableStyling:{tableLayout:"fixed"}};
    
    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h2 className="title-breadcrum">MHC Transaction Logs</h2>
                            <h6>All transactions for Modena Home Centers</h6>
                        </div>
                    </div>
                </div>
            </div>
            <section className="content">
                <div id="modal-trans" className='modal fade'>
                    <div className='modal-dialog modal-dialog-centered modal-xl'>
                        <div className='modal-content'>
                                <div className='modal-header'>
                                                <h5 className="modal-title"> Transaction Detail</h5>
                                                <button type="button" className="close" aria-label="Close" data-bs-dismiss="modal" onClick={onCloseDetailModal}>
                                                    <span aria-hidden="true">×</span>
                                                </button>
                                </div>
                                <div className='modal-body'>
                                    <h6 className='black bold'>Session Date:</h6>{moment(log_detail.sessiondate).format('ll LTS')}
                                    <br/>
                                    <br/>
                                    <div style={{wordWrap:"break-word"}}>
                                        <h6 className='black bold'>Parameter:</h6>
                                        <div>{log_detail.params}</div>
                                        <br/>
                                        <br/>
                                        <h6 className='black bold'>Response:</h6>
                                        <div>{log_detail.response}</div>
                                    </div>
                                  
                                </div>
                        </div>
                    </div>
                </div>
                <div className="container-fluid">
                    <div className="card shadow mb-4">
                        <div className="card-body">
                            <Overlay display={state.processing} />
                            <div className='table-responsive'>
                                <MTable {...propsTable} ref={tableStock} />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );

};

export default TransactionMHC;